module.exports = __webpack_public_path__ + "static/media/green-yellow.eefe4a90.png";